export default {
  state: {
    existingCiCdVariables: {},
  },
  mutations: {
    setExistingCiCdVariables(state, payload) {
      Vue.set(state.existingCiCdVariables, payload?.formName, payload?.variables);
    }
  },
  actions: {
    setExistingCiCdVariables(state, payload) {
      state.commit('setExistingCiCdVariables', payload);
    }
  },
  getters: {
    getExistingCiCdVariables: (state) => (formName) => state.existingCiCdVariables[formName] || null
  }
}
